<div class="button-container">
  <!-- <p-button label="Anular" [text]="true"></p-button> -->
  <!-- <div style="height: 2rem;"></div> -->
  <!-- <p-button label="Plain" [text]="true" [plain]="true"></p-button> -->
  <!-- <div style="height: 2rem;"></div> -->
  <p-button label="Anular" styleClass="p-button-rounded p-button-text" (onClick)="openModal()"></p-button>
  <!-- <p-button [label]="'Continuar con Webpay'" styleClass="p-button-rounded"></p-button> -->
</div>